import { Component, forwardRef, Inject, OnInit } from '@angular/core';
import { CatalogWidgetDirective, IBaseItem } from '@app/shared/components/catalog/catalog-widgets/catalog-widget';
import { NgAisInstantSearch } from 'angular-instantsearch';
import { connectHitsPerPage } from 'instantsearch.js/es/connectors';

@Component({
  selector: 'vc-catalog-widget-hits-per-page',
  templateUrl: './catalog-widget-hits-per-page.component.html',
  styleUrls: ['./catalog-widget-hits-per-page.component.scss']
})
export class CatalogWidgetHitsPerPageComponent extends CatalogWidgetDirective implements OnInit {
  state: {
    items: IBaseItem[];
    refine: (value: string) => void;
    hasNoResults: boolean;
    widgetParams: {};
  };

  constructor(@Inject(forwardRef(() => NgAisInstantSearch)) public instantSearchParent) {
    super('CatalogWidgetHitsPerPageComponent');
  }

  ngOnInit() {
    this.createWidget(connectHitsPerPage, {
      items: [
        { value: 60, label: '60', default: true },
        { value: 120, label: '120' }
      ]
    });
    super.ngOnInit();
  }
}
